export default "__VITE_ASSET__C$hc$jqA__"